import VueImageCropper from "./main.vue"

/* istanbul ignore next */
VueImageCropper.install = function (Vue) {
  Vue.component(VueImageCropper.name, VueImageCropper)
}

export default VueImageCropper